import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, type ButtonProps } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';

export const CancelButton: FC<ButtonProps> = ({ children, ...props }) => {
  const { t } = useTranslation();

  return (
    <Button variant="outlined" startIcon={<CloseOutlined />} {...props}>
      {children ?? t('cancel')}
    </Button>
  );
};
